import Grid from "@mui/material/Grid";
import type { ContasReceberView } from "../types/contas-receber.types";
import FinanceiroResumoCard from "./FinanceiroResumoCard";

type Props = {
  resumo: ContasReceberView["resumo"] | null;
  loading?: boolean;
};

export default function ContasReceberResumoCards({ resumo, loading }: Props) {
  const r = resumo;
  const qVenc = r?.quantidadeVencido ?? 0;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <FinanceiroResumoCard
          titulo="Total em aberto"
          valor={r?.totalAberto}
          formato="moeda"
          loading={loading}
          tipo="neutro"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FinanceiroResumoCard
          titulo="Vencidos"
          valor={r?.totalVencido}
          formato="moeda"
          loading={loading}
          tipo="alerta"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FinanceiroResumoCard
          titulo="Vencem hoje"
          valor={r?.totalVenceHoje}
          formato="moeda"
          loading={loading}
          tipo="alerta"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FinanceiroResumoCard
          titulo="Recebidos"
          valor={r?.totalRecebido}
          formato="moeda"
          loading={loading}
          tipo="positivo"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FinanceiroResumoCard
          titulo="Próximos 30 dias"
          valor={r?.totalProximos30Dias}
          formato="moeda"
          loading={loading}
          tipo="neutro"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FinanceiroResumoCard
          titulo="Quantidade vencida"
          valor={qVenc}
          formato="numero"
          loading={loading}
          tipo={qVenc > 0 ? "alerta" : "neutro"}
        />
      </Grid>
    </Grid>
  );
}
